import { Amplify } from 'aws-amplify'
import awsExports from '../aws-exports.js'
import AuthServiceImpl from './auth'
import StudioServiceImpl from './studio_service'
import UserServiceImpl from './user_service'

export default class APILibrary {
  studio: StudioServiceImpl
  auth: AuthServiceImpl
  user: UserServiceImpl

  private static ranConfigure = false

  constructor () {
    void APILibrary.runConfiguration()
    this.studio = new StudioServiceImpl()
    this.auth = new AuthServiceImpl()
    this.user = new UserServiceImpl()
  }

  static async runConfiguration (): Promise<void> {
    console.log('running configuration')
    if (this.ranConfigure) {
      return
    }

    Amplify.configure(awsExports)
    this.ranConfigure = true
  }
}

const library = new APILibrary()

const StudioService = library.studio
const AuthService = library.auth
const UserService = library.user

export {
  StudioService,
  UserService,
  AuthService
}
